<template>
  <!-- Block button -->
  <button
    class="w-full h-12 px-6 text-white text-sm transition-colors duration-150 ring-1 ring-green-light bg-green-light rounded-lg focus:outline-none font-semibold"
    :class="classStr"
    @click="$emit('click')"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    classStr: String,
  },
};
</script>